import { Component, OnInit } from "@angular/core";
import { FormArray, FormGroup, FormControl, Validators } from "@angular/forms";
import { ActivatedRoute,Router } from "@angular/router";
import { LabService } from "../lab-services/lab.service";

@Component({
  selector: "app-addlab",
  templateUrl: "./addlab.component.html",
  styleUrls: ["./addlab.component.css"],
})
export class AddlabComponent implements OnInit {
  lab: any;
  servicesArray: FormArray;
  lbForm: FormGroup;
  token: string;
  labid: any;
  authdata: any;
  constructor(
    private labService: LabService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit() {
    this.onInitForm();
    this.labid = this.activatedRoute.snapshot.queryParams["id"];
    if (this.labid) {
      this.getSingleLab();
    }
    if(localStorage.getItem('authData')){
      let dd = localStorage.getItem('authData');
      this.authdata=JSON.parse(dd);
      this.token=this.authdata.token;
      console.log(this.authdata)
    }
  }
  alrt(){
    alert("lab added sucessfully");
  }
  onInitForm() {

    
    /* const name = this.lab ? this.lab.name : null;
    const email = this.lab ? this.lab.price : null;
    const password = this.lab ? this.lab.duration : null;
    const description = this.lab ? this.lab.description : null;
    const phoneNo = this.lab ? this.lab.courseShift : null;

    const line1 = this.lab.address.line1 ? this.lab.address.line1 : null;
    const district = this.lab.address.district
      ? this.lab.address.district
      : null;
    const city = this.lab.address.city ? this.lab.address.city : null;
    const pincode = this.lab.address.pincode ? this.lab.address.pincode : null;
    const state = this.lab.address.state ? this.lab.address.state : null;*/
    this.servicesArray = new FormArray([
      new FormGroup({
        serviceName: new FormControl(null),
        price: new FormControl(null),
      }),
    ]);

    /*  if (this.couId && this.course.overview && this.course.overview.length > 0) {
      this.servicesArray = new FormArray([]);
      this.course.overview.forEach((element) => {
        this.servicesArray.push(
          new FormGroup({
            name: new FormControl(element.name),
            description: new FormControl(element.description),
          })
        );
      });
    }*/

    this.lbForm = new FormGroup({
      name: new FormControl(null, Validators.required),
      email: new FormControl(null, [Validators.required, Validators.email]),
      phoneNo: new FormControl(null, [
        Validators.required,
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),
      ]),
      password: new FormControl(null, Validators.required),

      description: new FormControl(null, Validators.required),
      line1: new FormControl(null, Validators.required),
      startTime: new FormControl(null, Validators.required),
      endTime: new FormControl(null, Validators.required),

      city: new FormControl(null, Validators.required),

      pincode: new FormControl(null, [
        Validators.required,
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),
      ]),
      state: new FormControl(null, Validators.required),
      services: this.servicesArray,
    });
  }
  get controls() {
    return (this.lbForm.get("services") as FormArray).controls;
  }
  
  onAddFormArray() {
    this.servicesArray.push(
      new FormGroup({
        serviceName: new FormControl(null),
        price: new FormControl(null),
      })
    );
  }
  onSubmit() {
    if (this.labid) {
      const data = { ...this.lbForm.value, id: this.labid };
      console.log("lab data");
      this.labService.updatelabToDatabase(data, this.token).subscribe((res:any) => {
          this.router.navigate(['pas/lab'])
        });
    } else {
      this.labService
        .saveLabToDatabase(this.lbForm.value, this.token)
        .subscribe((res) => {
          this.router.navigate(['pas/lab'])
          console.log(res);
        },(err:any)=>{
          alert(err.message)
        });
    }
  }
  onRemoveArray(i) {
    this.controls.splice(i, 1);
  }

  getSingleLab() {
    this.labService.getSinglelab(this.labid, this.token).subscribe((res:any) => {
      this.lab = res.labs;
      if (this.lab) {
        this.onUpdateForm();
      }
    });
  }
  onUpdateForm() {
    this.servicesArray = new FormArray([]);
    console.log(new Date(new Date().getTime()));
    const name = this.lab ? this.lab.name : null;
    const email = this.lab ? this.lab.email : null;
    const password = this.lab ? this.lab.duration : null;
    const description = this.lab ? this.lab.description : null;
    const phoneNo = this.lab ? this.lab.phoneNo : null;

    const line1 = this.lab.address.line1 ? this.lab.address.line1 : null;

    const city = this.lab.address.city ? this.lab.address.city : null;
    const pincode = this.lab.address.pincode ? this.lab.address.pincode : null;
    const state = this.lab.address.state ? this.lab.address.state : null;
    const startTime = this.lab.laTiming.startTime
      ? this.lab.laTiming.startTime
      : null;
    const endTime = this.lab.laTiming.endTime
      ? this.lab.laTiming.endTime
      : null;

    if (this.lab.services && this.lab.services.length > 0) {
      this.lab.services.forEach((element) => {
        this.servicesArray.push(
          new FormGroup({
            serviceName: new FormControl(element.serviceName),
            price: new FormControl(element.price),
          })
        );
      });
    }
    this.lbForm = new FormGroup({
      name: new FormControl(name, Validators.required),
      email: new FormControl(email, [Validators.required, Validators.email]),
      phoneNo: new FormControl(phoneNo, [
        Validators.required,
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),
      ]),

      description: new FormControl(description, Validators.required),
      line1: new FormControl(line1, Validators.required),
      startTime: new FormControl(startTime, Validators.required),
      endTime: new FormControl(endTime, Validators.required),

      city: new FormControl(city, Validators.required),

      pincode: new FormControl(pincode, [
        Validators.required,
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),
      ]),
      state: new FormControl(state, Validators.required),
      services: this.servicesArray,
    });
  }
}
